import { AlertType } from 'root/apps/components/AlertMessageDisplay/AlertMessageDisplay';

export const CommonAlertMessages: Record<string, string> = {
  GENERIC_ERROR: 'Something went wrong. Try again or contact support if the problem persists.',
};

export const getCommonAlertMessage = (ErrorType: keyof typeof CommonAlertMessages): string => {
  return CommonAlertMessages[ErrorType];
};

export interface InventoryCountReconcileError extends Error {
  type: AlertType;
  title?: string;
}

export interface InventoryCountReconcileErrorOptions {
  type?: AlertType;
  title?: string;
}
export class InventoryCountReconcileError extends Error implements InventoryCountReconcileError {
  constructor(message: string, options: InventoryCountReconcileErrorOptions = {}) {
    super(message);
    this.name = 'InventoryCountReconcileError';
    this.title = options.title;
    this.type = options.type || 'danger';
  }
}
